/**
 * Push an event to the GTM dataLayer.
 * GTM / GA4 tags and triggers are configured by the marketing team.
 * Devs only call this function — no direct gtag() calls.
 *
 * @param {Object} payload - Must include an `event` string; add any extra properties.
 * @param {Function} [onDone] - Optional callback after GTM processes the event
 *   (or after timeout). Use before redirects so the GA4 hit is not cancelled.
 */

var CONNECT_STARTED_KEY = 'sk_gtm_connect_store_started'
var CONNECT_SUCCESS_FIRED_KEY = 'sk_gtm_connect_store_success_fired'
var CONNECT_METHOD_KEY = 'sk_gtm_connect_store_method'

export function pushGtmEvent (payload, onDone) {
  window.dataLayer = window.dataLayer || []
  var done = typeof onDone === 'function' ? onDone : null
  if (!done) {
    window.dataLayer.push(payload)
    return
  }

  var finished = false
  var timeoutMs = (payload && payload.eventTimeout) || 2000
  function finish () {
    if (finished) return
    finished = true
    done()
  }

  var pushPayload = Object.assign({}, payload, {
    eventCallback: finish,
    eventTimeout: timeoutMs
  })
  window.dataLayer.push(pushPayload)
  // Fallback if GTM never invokes eventCallback (blocked / not loaded)
  setTimeout(finish, timeoutMs)
}

/** Mark that user started Amazon connect (survives OAuth redirect). +method+: how they signed up. */
export function markConnectStoreStarted (method) {
  try {
    sessionStorage.setItem(CONNECT_STARTED_KEY, '1')
    sessionStorage.removeItem(CONNECT_SUCCESS_FIRED_KEY)
    if (method) sessionStorage.setItem(CONNECT_METHOD_KEY, method)
    else sessionStorage.removeItem(CONNECT_METHOD_KEY)
  } catch (e) { /* noop */ }
}

/**
 * Fire connect_store_success once after OAuth return when a store is connected.
 * Safe to call from /connect, /welcome, or /home — only fires if Authorize was clicked.
 * Carries the method passed to markConnectStoreStarted (email / google / invite).
 */
export function maybeFireConnectStoreSuccess () {
  var method = null
  try {
    if (sessionStorage.getItem(CONNECT_SUCCESS_FIRED_KEY) === '1') return false
    if (sessionStorage.getItem(CONNECT_STARTED_KEY) !== '1') return false
    method = sessionStorage.getItem(CONNECT_METHOD_KEY)
    sessionStorage.setItem(CONNECT_SUCCESS_FIRED_KEY, '1')
    sessionStorage.removeItem(CONNECT_STARTED_KEY)
    sessionStorage.removeItem(CONNECT_METHOD_KEY)
  } catch (e) {
    return false
  }
  var payload = { event: 'connect_store_success', step: 2 }
  if (method) payload.method = method
  pushGtmEvent(payload)
  return true
}

/**
 * Push connect_store_success immediately (Amazon sign-up finishes inside /signup, so the
 * OAuth-return flag never gets a chance to fire). Also marks it fired so /welcome does not send it twice.
 */
export function fireConnectStoreSuccess (method, onDone) {
  try {
    if (sessionStorage.getItem(CONNECT_SUCCESS_FIRED_KEY) === '1') {
      if (typeof onDone === 'function') onDone()
      return false
    }
    sessionStorage.setItem(CONNECT_SUCCESS_FIRED_KEY, '1')
    sessionStorage.removeItem(CONNECT_STARTED_KEY)
    sessionStorage.removeItem(CONNECT_METHOD_KEY)
  } catch (e) { /* still push the event */ }
  var payload = { event: 'connect_store_success', step: 2 }
  if (method) payload.method = method
  pushGtmEvent(payload, onDone)
  return true
}



// WEBPACK FOOTER //
// ./src/utils/gtmEvents.js